export const styles = {
  contentContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    position: "relative",
  },
};
